import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getLink } from "../../dataProvider/links.js";

import emailSent from "../../img/v1/user/email-sent.svg";

import "../../scss/v2/user/passwordSent.scss"

function PasswordSent(props) {

    const { t, i18n} = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(props.lang)
    }, [i18n, props.lang])

    return(
        <div className="password-sent">
            <div className="row">
                <div className="col-12 col-lg-6 offset-lg-3 text-center">
                    <img className="img img-fluid password-sent-image" src={emailSent} alt={emailSent} />
                    <h1 className="password-sent-title">{t('passwordSent.title')}</h1>
                    <p className="password-sent-subtitle">{t('passwordSent.subtitle')}</p>
                    <Link to={getLink("login", i18n.language)}>
                        <button className="button orange-button">{t('passwordSent.button')}</button>
                    </Link>
                </div>
            </div>
        </div>
    )

}

export default PasswordSent